import { GroupedRoute } from "./types/transitTypes";

// Action types for the reducer
type Action =
  | { type: "SET_FROM_LOCATION"; payload: google.maps.LatLngLiteral | null }
  | { type: "SET_TO_LOCATION"; payload: google.maps.LatLngLiteral | null }
  | { type: "SET_DATE"; payload: string }
  | { type: "SET_TIME"; payload: string }
  | { type: "SET_DIRECTIONS"; payload: google.maps.DirectionsResult | null }
  | {
      type: "SET_FILTERED_DIRECTIONS";
      payload: google.maps.DirectionsResult | null;
    }
  | { type: "SET_GROUPED_ROUTES"; payload: GroupedRoute[] }
  | { type: "SET_WARNING"; payload: string | null }
  | { type: "SET_CURRENT_ROUTE_INDEX"; payload: number }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "RESET_SEARCH" };

// State interface for the transit planner
interface TransitPlannerState {
  fromLocation: google.maps.LatLngLiteral | null;
  toLocation: google.maps.LatLngLiteral | null;
  selectedDate: string;
  selectedTime: string;
  directions: google.maps.DirectionsResult | null;
  filteredDirections: google.maps.DirectionsResult | null;
  groupedRoutes: GroupedRoute[];
  warning: string | null;
  currentRouteIndex: number;
  isLoading: boolean;
}

// Initial state for the reducer
export const initialState: TransitPlannerState = {
  fromLocation: null,
  toLocation: null,
  selectedDate: "",
  selectedTime: "",
  directions: null,
  filteredDirections: null,
  groupedRoutes: [],
  warning: null,
  currentRouteIndex: 0,
  isLoading: false,
};

// Reducer to manage transit planner state
export const transitPlannerReducer = (
  state: TransitPlannerState,
  action: Action
): TransitPlannerState => {
  switch (action.type) {
    case "SET_FROM_LOCATION":
      return { ...state, fromLocation: action.payload };
    case "SET_TO_LOCATION":
      return { ...state, toLocation: action.payload };
    case "SET_DATE":
      return { ...state, selectedDate: action.payload };
    case "SET_TIME":
      return { ...state, selectedTime: action.payload };
    case "SET_DIRECTIONS":
      return { ...state, directions: action.payload };
    case "SET_FILTERED_DIRECTIONS":
      return { ...state, filteredDirections: action.payload };
    case "SET_GROUPED_ROUTES":
      return { ...state, groupedRoutes: action.payload };
    case "SET_WARNING":
      return { ...state, warning: action.payload };
    case "SET_CURRENT_ROUTE_INDEX":
      return { ...state, currentRouteIndex: action.payload };
    case "SET_LOADING":
      return { ...state, isLoading: action.payload };
    case "RESET_SEARCH":
      return {
        ...state,
        directions: null,
        filteredDirections: null,
        groupedRoutes: [],
        warning: null,
        currentRouteIndex: 0,
        isLoading: false,
      };
    default:
      return state;
  }
};
